import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';
import { FormattedMessage } from 'react-intl';
import Pagination from 'components/pagination';
import ErrorTryAgain from 'components/ErrorTryAgain';
import PaneSpinner from 'components/PaneSpinner';
import { Urls } from 'apps/find-designers/propTypes';
import DesignerList from './DesignerList';
import ResultsOverview from './ResultsOverview';
import StoreFront from './StoreFront';
import SignUpCta from './SignUpCta';
import { SearchContext } from './SearchContext';
import { ApolloProvider, Query } from 'react-apollo';
import { GET_CREATORS, GET_FEATURED_SEARCHES } from './SearchQueries';
import ApolloClient from 'apollo-boost';
import Cookies from 'cookies-js';
import { MAX_RESULTS, SEARCH_SIZE } from 'apps/find-designers/consts';
import { getFeaturedSearches, getFeaturedSearchRequests } from './FeaturedSearchBuilder';
import { Spinner } from '@99designs/common/components/Spinner';

let scrollToComponent;

class ResultsPane extends Component {
    constructor(props) {
        super(props);

        this.client = new ApolloClient({
            uri: '/app/graphql',
            headers: {
                'X-Csrf-Token': Cookies.get('_99csrf'),
            },
        });

        this.retry = this.retry.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
    }

    componentDidMount() {
        // https://github.com/component/scroll-to/issues/9#issuecomment-311362354 (same deal, but in mocha)
        scrollToComponent = require('react-scroll-to-component'); // eslint-disable-line
    }

    scrollToTop() {
        scrollToComponent(this.bodyElement, {
            duration: 500,
            align: 'top',
            offset: -30,
            ease: 'in-out-quart',
        });
    }

    retry() {
        window.location.reload(true);
    }

    footer(pagination) {
        return (
            <SearchContext.Consumer>
                {context => {
                    if (!context.currentUser.isIdentified) {
                        return <SignUpCta signUpCtaUrl={this.props.urls.signUpCtaUrl} />;
                    }

                    return (
                        <div className="results-pane__pagination">
                            <Pagination
                                path={this.props.urls.rootPath}
                                currentPage={pagination.currentPage}
                                totalPages={pagination.totalPages}
                                searchString={this.props.searchString}
                                onClick={this.scrollToTop}
                            />
                        </div>
                    );
                }}
            </SearchContext.Consumer>
        );
    }

    loading() {
        if (this.bodyElement) {
            const paneRect = this.bodyElement.getBoundingClientRect();
            return (
                <PaneSpinner
                    paneTop={paneRect.top}
                    viewportHeight={document.documentElement.clientHeight}
                    paneHeight={paneRect.height}
                />
            );
        }

        return <Spinner variations={['centered', 'large', 'soft']} />;
    }

    error() {
        return (
            <FormattedMessage id="error_message">
                {message => <ErrorTryAgain onRetry={this.retry} message={message} />}
            </FormattedMessage>
        );
    }

    getPage() {
        const params = new URLSearchParams(window.location.search);
        const page = parseInt(params.get('page'));
        return page ? page : 1;
    }

    searchRequest(page) {
        return {
            from: (page - 1) * SEARCH_SIZE,
            size: SEARCH_SIZE,
            filterBy: {
                ...this.props.filters,
            },
        };
    }

    storeFront() {
        const featuredSearches = getFeaturedSearches();

        return (
            <Query
                query={GET_FEATURED_SEARCHES}
                variables={{ ...getFeaturedSearchRequests(featuredSearches) }}
            >
                {({ loading, error, data }) => {
                    if (loading) return this.loading();
                    if (error) return this.error();

                    return (
                        <StoreFront
                            searches={featuredSearches}
                            results={data}
                            onClick={this.scrollToTop}
                        />
                    );
                }}
            </Query>
        );
    }

    searchResults() {
        const currentPage = this.getPage();
        const request = this.searchRequest(currentPage);

        return (
            <Query query={GET_CREATORS} variables={{ request }}>
                {({ loading, error, data }) => {
                    if (loading) return this.loading();
                    if (error) return this.error();

                    const totalResults = Math.min(data.creators.totalHits, MAX_RESULTS);
                    const totalPages = Math.ceil(totalResults / SEARCH_SIZE);

                    return (
                        <div className="results-pane">
                            <div className="results-pane__overview">
                                <ResultsOverview
                                    totalResults={totalResults}
                                    onClear={this.props.onClear}
                                    onReset={this.props.onReset}
                                />
                            </div>
                            <div className="results-pane__body">
                                <DesignerList designers={data.creators.hits} />
                            </div>
                            {this.footer({
                                currentPage: currentPage,
                                totalPages: totalPages,
                                totalResults: totalResults,
                            })}
                        </div>
                    );
                }}
            </Query>
        );
    }

    render() {
        return (
            <div
                className="results-pane__root"
                ref={element => {
                    this.bodyElement = element;
                }}
            >
                <ApolloProvider client={this.client}>
                    {this.props.storeFront === true ? this.storeFront() : this.searchResults()}
                </ApolloProvider>
            </div>
        );
    }
}

ResultsPane.propTypes = {
    urls: Urls.isRequired,
    filters: PropTypes.object.isRequired,
    searchString: PropTypes.string.isRequired,
    setTimeout: PropTypes.func.isRequired,
    storeFront: PropTypes.bool.isRequired,
    onReset: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
};

export default ReactTimeout(ResultsPane);



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/ResultsPane.jsx